var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.1,
    d: "m13.73 9.219-2.917 5.052a4.667 4.667 0 0 0 8.083 4.666l4.666-8.082a4.667 4.667 0 0 0-4.964-6.908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.1,
    d: "M9.402 22.887a4.667 4.667 0 0 1-4.965-6.908l4.667-8.083a4.667 4.667 0 1 1 8.083 4.667l-2.916 5.051"
  })));
};
export default SvgPaperclip;